import React, { useState } from 'react';
import { FAQ_DATA } from '../mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { Input } from '../components/ui/input';
import { Search, Mail } from 'lucide-react';
import { Card } from '../components/ui/card';

const FAQ = () => {
  const [q, setQ] = useState('');

  const filter = (items) => items.filter(i =>
    !q || i.q.toLowerCase().includes(q.toLowerCase()) || i.a.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div>
      <section className="hero-gradient text-white py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold">Veelgestelde vragen</h1>
          <p className="text-slate-200 mt-4 max-w-2xl mx-auto">Antwoorden op de meest gestelde vragen over boetes, bezwaar en onze werkwijze.</p>
          <div className="mt-8 max-w-xl mx-auto relative">
            <Search className="w-5 h-5 absolute left-4 top-3.5 text-slate-500" />
            <Input
              value={q}
              onChange={e => setQ(e.target.value)}
              placeholder="Zoek een vraag..."
              className="pl-11 h-12 bg-white text-slate-900 border-0"
            />
          </div>
        </div>
      </section>

      <section className="py-14 max-w-4xl mx-auto px-4 md:px-6">
        {FAQ_DATA.map(section => {
          const items = filter(section.items);
          if (!items.length) return null;
          return (
            <div key={section.category} className="mb-10">
              <h2 className="text-2xl font-bold text-[#1e1b4b] mb-4">{section.category}</h2>
              <Accordion type="single" collapsible className="space-y-2">
                {items.map((i, idx) => (
                  <AccordionItem key={idx} value={`${section.category}-${idx}`} className="border border-slate-200 rounded-lg px-4 bg-white">
                    <AccordionTrigger className="text-left text-[#1e1b4b] font-semibold hover:no-underline">{i.q}</AccordionTrigger>
                    <AccordionContent className="text-slate-700 leading-relaxed">{i.a}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          );
        })}

        <Card className="mt-10 p-6 md:p-8 bg-slate-50 border border-slate-200">
          <div className="font-bold text-[#1e1b4b] text-lg">Vraag niet beantwoord?</div>
          <p className="text-slate-600 mt-2">Neem contact met ons op via e-mail. We reageren meestal binnen 1 werkdag.</p>
          <div className="mt-4 flex flex-wrap gap-3">
            <a href="mailto:info@bezwaarmeesters.nl" className="inline-flex items-center gap-2 bg-[#1e1b4b] text-white px-4 py-2 rounded-md hover:bg-[#2a2464]">
              <Mail className="w-4 h-4" /> E-mail
            </a>
          </div>
        </Card>
      </section>
    </div>
  );
};

export default FAQ;
